import formTermsMixin from '@phoenix/mixins/formTermsMixin';

export default {
  mixins: [formTermsMixin],

  props: {
    form: {
      type: Object,
      default: () => ({}), // TODO: change this to required when all forms are adapted to the new form system
    },
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      fields: {},
    };
  },

  computed: {
    shouldDisplayForm() {
      return true;
    },
  },

  watch: {
    'form.fields': {
      handler(value) {
        if (value !== undefined) {
          this.setFields(value);
        }
      },
      immediate: true,
    },
  },

  methods: {
    setFields(fields) {
      this.fields = { ...this.fields, ...fields };
    },
  },
};
